import { useEffect, useRef } from 'react';

import router from 'routes';
import { syncRumSessionIdentityFromStorage } from './rumAnalytics';
import { getAwsRum } from './initRum';
import { getRumPageViewPayload, rumPageIdFromWindow } from './rumPageId';

/**
 * Records a RUM page view on each React Router navigation (route path + search).
 * Internal MUI tabs on the same route are not separate views until phase 2.
 */
export default function RumNavigationSync() {
  const lastPathRef = useRef('');

  useEffect(() => {
    const rum = getAwsRum();
    if (!rum) return undefined;
    syncRumSessionIdentityFromStorage();

    // Use the same page payload everywhere so pageId, feature key, and tags stay aligned.
    const recordPath = () => {
      const pageId = rumPageIdFromWindow();
      if (pageId === lastPathRef.current) return;
      lastPathRef.current = pageId;
      try {
        rum.recordPageView(getRumPageViewPayload(window.location.pathname || '/'));
      } catch (_) {
        /* ignore */
      }
    };

    recordPath();

    return router.subscribe(() => {
      recordPath();
    });
  }, []);

  return null;
}
